import { createFileRoute, notFound } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import WorkspaceDailyOverviewPage from "@/components/Workspace/WorkspaceDailyOverviewPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.daily-overview"),
        icon: <Icon.DAILY_OVERVIEW />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: WorkspaceDailyOverviewPage,
});
